module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin-top": "3.0em"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/08_foreword#foreword",
      "id": "rforeword"
    }
  }, [_c('em', [_vm._v("Foreword")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/09_acknowledgements#acknowledgements",
      "id": "racknowledgements"
    }
  }, [_c('em', [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/10_chapter1#ch01",
      "id": "rch01"
    }
  }, [_vm._v(" 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/10_chapter1#ch01"
    }
  }, [_vm._v("Briefing")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/11_chapter2#ch02",
      "id": "rch02"
    }
  }, [_vm._v(" 2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/11_chapter2#ch02"
    }
  }, [_vm._v("The Armies which Passed in the Night")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter3#ch03",
      "id": "rch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter3#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Long Road to a Barren Hillside")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter4#ch04",
      "id": "rch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter4#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Not Fit to Fight In’")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ch05",
      "id": "rch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 5")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter5#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U-Go: Overture and Beginners")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter6#ch06",
      "id": "rch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 6")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter6#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U-Go: The Siege")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter7#ch07",
      "id": "rch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 7")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter7#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U-Go: Relief and Pursuit")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter8#ch08",
      "id": "rch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter8#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Firm Base for a Deadly Thrust")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter9#ch09",
      "id": "rch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter9#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Master Stroke")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter10#ch10",
      "id": "rch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Battle of the Irrawaddy Bend")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11#ch11",
      "id": "rch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End in Arakan")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter12#ch12",
      "id": "rch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Roads to Rangoon")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/22_appendixA#appendixA",
      "id": "rappendixA",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix A")]), _vm._v(" –Some Notes on the Imperial Japanese Armoured Corps")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/23_appendixB#appendixB",
      "id": "rappendixB",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix B")]), _vm._v(" – Brief Technical Data of Allied Tanks which, Fought in Burma")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/24_appendixC#appendixC",
      "id": "rappendixC",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix C")]), _vm._v(" – Table of Approximately Equivalent Ranks, British and Indian Cavalry")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/25_bibliography#bibliography",
      "id": "rbibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/26_index#index",
      "id": "rindex",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a20273","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_contents.vue
// module id = 66
// module chunks = 0